---
de:
  add_company: Unternehmen hinzufügen
  add_parent_company: Muttergesellschaft hinzufügen
  cancel: Abbrechen
  companies:
    community_access_locked: Community-Beiträge sind vom Mutterunternehmen deaktiviert
    delete_company: Unternehmen löschen
    errors:
      missing_company: Das Unternehmen muss für die Baumansicht vorhanden sein.
  delete: Löschen
  edit: Bearbeiten
  external_URLs: Externe URLs
  kiosk_mode_setup: Kiosk-Modus-Einrichtung
  name: Name
  ownership_share: Beteiligungsquote
  ownership_share_saves_on_exit: Speichert beim Verlassen
  ownership_share_unlock: Zum Ändern der Beteiligungsquote entsperren. Sie wird gespeichert, sobald das Feld verlassen wird.
  parent_companies: Muttergesellschaften
  parent_company_last_parent_locked: Die letzte Muttergesellschaft kann nicht entfernt werden. Um dieses Unternehmen zur obersten Ebene zu machen, bitte den Support kontaktieren.
  parent_company_locked: Gesperrt
  portal_config: Portal-Konfiguration
  save: Speichern
  select_parent_company: Muttergesellschaft auswählen
  subsidiaries: Tochtergesellschaften
